import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "table-row"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    return (_ctx.item)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createCommentVNode(" 정산일은 경우에 따라 함수 적용 "),
                    (header.value === 'formattedDate' && _ctx.isDateNavigationEnabled)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: header.value + index,
                            class: _normalizeClass(`td__${header.align} td__navigator`)
                        }, [
                            _createElementVNode("span", {
                                class: "td__navigator",
                                onClick: ($event) => (_ctx.handleClickNavigator(_ctx.item[header.value]))
                            }, _toDisplayString(_ctx.item[header.value]), 9 /* TEXT, PROPS */, _hoisted_2)
                        ], 2 /* CLASS */))
                        : (header.value === 'formattedStoreType')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" storeType은 chip으로 적용 "),
                                (_openBlock(), _createElementBlock("td", {
                                    key: header.value + index,
                                    class: _normalizeClass(`td__${header.align}`)
                                }, [
                                    _createCommentVNode(" template 내 ts 애러 추후해소(하준) 위에 item 선언했는데.. "),
                                    _createVNode(_component_Chip, {
                                        text: _ctx.item[header.value].text,
                                        "brg-chip-color": _ctx.getChipColor(header)
                                    }, null, 8 /* PROPS */, ["text", "brg-chip-color"])
                                ], 2 /* CLASS */))
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (header.value === 'formattedIsAdjustmentByHeadOffice')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createCommentVNode(" isAdjustmentByHeadOffice은 img로 적용 "),
                                    (_openBlock(), _createElementBlock("td", {
                                        key: header.value + index,
                                        class: _normalizeClass(`ta-c`)
                                    }, [
                                        _createElementVNode("img", {
                                            src: _ctx.item[header.value]
                                        }, null, 8 /* PROPS */, _hoisted_3)
                                    ]))
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                : (header.align === 'center')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createCommentVNode(" 허브 정산 정렬을 table header에서 정의 할 예정 20250226 윤태건 "),
                                        (_openBlock(), _createElementBlock("td", {
                                            key: header.value + index,
                                            class: "ta-c",
                                            title: _ctx.item[header.value]
                                        }, _toDisplayString(_ctx.item[header.value]), 9 /* TEXT, PROPS */, _hoisted_4))
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createCommentVNode(" 그 외 "),
                                        (_openBlock(), _createElementBlock("td", {
                                            key: header.value + index,
                                            class: "ta-c",
                                            title: _ctx.item[header.value]
                                        }, _toDisplayString(_ctx.item[header.value]), 9 /* TEXT, PROPS */, _hoisted_5))
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */));
            }), 256 /* UNKEYED_FRAGMENT */))
        ]))
        : _createCommentVNode("v-if", true);
}
